import { render, staticRenderFns } from "./ComingSoonWrapper.vue?vue&type=template&id=9f193d78"
import script from "./ComingSoonWrapper.vue?vue&type=script&lang=js"
export * from "./ComingSoonWrapper.vue?vue&type=script&lang=js"
import style0 from "./ComingSoonWrapper.vue?vue&type=style&index=0&id=9f193d78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports